import { render } from "./AudioPlayerEditModal.vue?vue&type=template&id=fb0043c8&scoped=true"
import script from "./AudioPlayerEditModal.vue?vue&type=script&lang=js"
export * from "./AudioPlayerEditModal.vue?vue&type=script&lang=js"

import "./AudioPlayerEditModal.vue?vue&type=style&index=0&id=fb0043c8&scoped=true&lang=less"
import "./AudioPlayerEditModal.vue?vue&type=style&index=1&id=fb0043c8&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0043c8"]])

export default __exports__